export default __webpack_public_path__ + "static/media/p14.6b41b4a4.jpg";